module.exports = __webpack_public_path__ + "img/P150T_weapon_13.ac681da8.png";